// BodySize
export const ContentBodyPadding = 16;
export const MaxContentBodySize = 800;
export const MaxEventBodySize = 294; // 이벤트

// Renewal
export const DesktopGlobalMenuWidth = 184;
export const DesktopNavigationWidth = 916;
export const DesktopContentWidth = 732;

// Offset
export const PCOffset = 916;

// Header
export const HeaderNavBarHeight = 56;

// MutableHeader
export const MutableHeaderNavBarMobileHeight = 56;

// GNB
export const MobileGNBMenuHeight = 56;
export const GNBHeight = 56;
export const GNBSubMenuHeight = 45;

// ContentBody
export const PageTitleHeight = 80;

// Footer
export const FooterHeight = 123;

// Editor
export const EditorNavBarHeight = HeaderNavBarHeight;

// Viewer
export const ViewerNavBarHeight = HeaderNavBarHeight;
// Media query
export const isPC = `min-width: ${PCOffset}px`;

// Margin
export const PageContentBottomMargin = 32;
